import { AfterViewInit, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { AuthShared } from 'src/app/auth/auth-shared.abstract';
import { promiseWithCatch, safelyDetectChanges } from 'src/app/common/app.helpers';
import AppValues from 'src/app/common/app.values';
import { FormValueService } from 'src/app/common/guards/save-data-guard/form-value.service';
import { IDeactivate } from 'src/app/common/guards/save-data-guard/save-data.interface';
import { OperationInfoService } from 'src/app/common/long-operations/operation-info.service';
import ProjectLinks from 'src/app/common/project.links';
import { ChangePassowordForm } from '../auth-form.inteface';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent
  extends AuthShared<ChangePassowordForm>
  implements OnInit, AfterViewInit, OnDestroy, IDeactivate
{
  public readonly DEBOUNCE_TIME: number = AppValues.DEBOUNCE_TIME;

  public isFormChanged = false;

  private operationInfoService = inject(OperationInfoService);
  private router = inject(Router);
  private formValueService = inject(FormValueService);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.initializeForm();
  }

  public ngAfterViewInit(): void {
    this.formValueService.saveFormValue({ ...this.form.value });
    this.subscribeToControlValueChanges();
  }

  public submit(): void {
    if (this.form.invalid) {
      this.validateAllFields();
      return;
    }

    this.formValueService.saveFormValue(this.form.value);

    const { currentPassword, password } = this.form.value;

    this.operationInfoService.setupOperation({ spinner: 'global', button: { id: 'login-form-login-btn' } }, () => {
      this.authService.changePassword({ old_password: currentPassword.trim(), password: password.trim() });
    });
  }

  public cancel(): void {
    promiseWithCatch(this.router.navigateByUrl(ProjectLinks.LINK_PROFILE_EDIT));
  }

  protected initializeForm(): void {
    this.form = new FormGroup(
      {
        currentPassword: new FormControl('', this.validationService.getValidators('oldPassword')),
        password: new FormControl('', this.validationService.getValidators('password')),
        repeatPassword: new FormControl('', this.validationService.getValidators('repeatPassword')),
      },

      this.validationService.getFormPasswordValidators(),
    );

    this.validateRepeatPasswordChanges();
    this.validatePasswordChanges('currentPassword');
  }

  private subscribeToControlValueChanges(): void {
    this.subscriptions$.push(
      combineLatest([this.form.valueChanges, this.formValueService.valueChanged]).subscribe(
        ([value, startValue]: [object, object]) => {
          this.isFormChanged = this.formValueService.formChangeDetection(value, startValue);
          safelyDetectChanges(this.changeDetector);
        },
      ),
    );
  }
}
